import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=0fc98eb9&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=0fc98eb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc98eb9",
  null
  
)

export default component.exports